/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AdvisorStatistics } from '../models/advisor-statistics';
import { BankExpenditures } from '../models/bank-expenditures';
import { BankIncomes } from '../models/bank-incomes';
import { CheckModelation } from '../models/check-modelation';
import { ComparatorClient } from '../models/comparator-client';
import { DetailedComparatorAdminViewResult } from '../models/detailed-comparator-admin-view-result';
import { ExternalBonitaModelation } from '../models/external-bonita-modelation';
import { ExternalBonitaResult } from '../models/external-bonita-result';
import { ExternalModelation } from '../models/external-modelation';
import { ExternalResult } from '../models/external-result';
import { Info } from '../models/info';
import { MaxCreditEndpoint } from '../models/max-credit-endpoint';
import { MaxCreditResult } from '../models/max-credit-result';
import { Modelation } from '../models/modelation';
import { ModelationConfig } from '../models/modelation-config';
import { ModelationResultCollection } from '../models/modelation-result-collection';
import { ModelationsOutput } from '../models/modelations-output';
import { Notice } from '../models/notice';
import { Payment } from '../models/payment';
import { PaymentCalendarInput } from '../models/payment-calendar-input';
import { RemovedModelations } from '../models/removed-modelations';
import { ReportFilter } from '../models/report-filter';
import { Status } from '../models/status';
import { UploadFiles } from '../models/upload-files';

@Injectable({
  providedIn: 'root',
})
export class ComparatorService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation activateNewGraphFile
   */
  static readonly ActivateNewGraphFilePath = '/api/comparator/activate-new-graph-file/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `activateNewGraphFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  activateNewGraphFile$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.ActivateNewGraphFilePath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `activateNewGraphFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  activateNewGraphFile(params?: {
  }): Observable<void> {

    return this.activateNewGraphFile$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation bankExpenditures
   */
  static readonly BankExpendituresPath = '/api/comparator/bank-expenditures/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bankExpenditures()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bankExpenditures$Response(params: {
    id: string;
    body: Modelation
  }): Observable<StrictHttpResponse<Array<BankExpenditures>>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.BankExpendituresPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<BankExpenditures>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `bankExpenditures$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bankExpenditures(params: {
    id: string;
    body: Modelation
  }): Observable<Array<BankExpenditures>> {

    return this.bankExpenditures$Response(params).pipe(
      map((r: StrictHttpResponse<Array<BankExpenditures>>) => r.body as Array<BankExpenditures>)
    );
  }

  /**
   * Path part for operation bankIncomes
   */
  static readonly BankIncomesPath = '/api/comparator/bank-incomes/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bankIncomes()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bankIncomes$Response(params: {
    id: string;
    body: Modelation
  }): Observable<StrictHttpResponse<Array<BankIncomes>>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.BankIncomesPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<BankIncomes>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `bankIncomes$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bankIncomes(params: {
    id: string;
    body: Modelation
  }): Observable<Array<BankIncomes>> {

    return this.bankIncomes$Response(params).pipe(
      map((r: StrictHttpResponse<Array<BankIncomes>>) => r.body as Array<BankIncomes>)
    );
  }

  /**
   * Path part for operation checkGraphFileState
   */
  static readonly CheckGraphFileStatePath = '/api/comparator/check-graph-file-state/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `checkGraphFileState()` instead.
   *
   * This method doesn't expect any request body.
   */
  checkGraphFileState$Response(params?: {
  }): Observable<StrictHttpResponse<Status>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.CheckGraphFileStatePath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Status>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `checkGraphFileState$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  checkGraphFileState(params?: {
  }): Observable<Status> {

    return this.checkGraphFileState$Response(params).pipe(
      map((r: StrictHttpResponse<Status>) => r.body as Status)
    );
  }

  /**
   * Path part for operation checkModelation
   */
  static readonly CheckModelationPath = '/api/comparator/check-modelation/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `checkModelation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  checkModelation$Response(params: {
    id: string;
    body?: CheckModelation
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.CheckModelationPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `checkModelation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  checkModelation(params: {
    id: string;
    body?: CheckModelation
  }): Observable<void> {

    return this.checkModelation$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation computeExternalBonitaModelation
   */
  static readonly ComputeExternalBonitaModelationPath = '/api/comparator/compute-external-bonita-modelation/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `computeExternalBonitaModelation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  computeExternalBonitaModelation$Response(params: {
    body: ExternalBonitaModelation
  }): Observable<StrictHttpResponse<ExternalBonitaResult>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.ComputeExternalBonitaModelationPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExternalBonitaResult>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `computeExternalBonitaModelation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  computeExternalBonitaModelation(params: {
    body: ExternalBonitaModelation
  }): Observable<ExternalBonitaResult> {

    return this.computeExternalBonitaModelation$Response(params).pipe(
      map((r: StrictHttpResponse<ExternalBonitaResult>) => r.body as ExternalBonitaResult)
    );
  }

  /**
   * Path part for operation computeExternalModelation
   */
  static readonly ComputeExternalModelationPath = '/api/comparator/compute-external-modelation/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `computeExternalModelation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  computeExternalModelation$Response(params: {
    body: ExternalModelation
  }): Observable<StrictHttpResponse<Array<ExternalResult>>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.ComputeExternalModelationPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ExternalResult>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `computeExternalModelation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  computeExternalModelation(params: {
    body: ExternalModelation
  }): Observable<Array<ExternalResult>> {

    return this.computeExternalModelation$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ExternalResult>>) => r.body as Array<ExternalResult>)
    );
  }

  /**
   * Path part for operation computeResults
   */
  static readonly ComputeResultsPath = '/api/comparator/compute-results/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `computeResults()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  computeResults$Response(params: {
    id: string;
    body: Modelation
  }): Observable<StrictHttpResponse<ModelationResultCollection>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.ComputeResultsPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ModelationResultCollection>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `computeResults$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  computeResults(params: {
    id: string;
    body: Modelation
  }): Observable<ModelationResultCollection> {

    return this.computeResults$Response(params).pipe(
      map((r: StrictHttpResponse<ModelationResultCollection>) => r.body as ModelationResultCollection)
    );
  }

  /**
   * Path part for operation duplicateModelation
   */
  static readonly DuplicateModelationPath = '/api/comparator/duplicate-modelation/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `duplicateModelation()` instead.
   *
   * This method doesn't expect any request body.
   */
  duplicateModelation$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<Modelation>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.DuplicateModelationPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Modelation>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `duplicateModelation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  duplicateModelation(params: {
    id: string;
  }): Observable<Modelation> {

    return this.duplicateModelation$Response(params).pipe(
      map((r: StrictHttpResponse<Modelation>) => r.body as Modelation)
    );
  }

  /**
   * Path part for operation findMaxCredit
   */
  static readonly FindMaxCreditPath = '/api/comparator/find-max-credit/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findMaxCredit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findMaxCredit$Response(params: {
    id: string;
    body: MaxCreditEndpoint
  }): Observable<StrictHttpResponse<Array<MaxCreditResult>>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.FindMaxCreditPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<MaxCreditResult>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findMaxCredit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findMaxCredit(params: {
    id: string;
    body: MaxCreditEndpoint
  }): Observable<Array<MaxCreditResult>> {

    return this.findMaxCredit$Response(params).pipe(
      map((r: StrictHttpResponse<Array<MaxCreditResult>>) => r.body as Array<MaxCreditResult>)
    );
  }

  /**
   * Path part for operation freezeModelation
   */
  static readonly FreezeModelationPath = '/api/comparator/freeze-modelation/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `freezeModelation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  freezeModelation$Response(params: {
    id: string;
    body?: RemovedModelations
  }): Observable<StrictHttpResponse<Modelation>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.FreezeModelationPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Modelation>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `freezeModelation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  freezeModelation(params: {
    id: string;
    body?: RemovedModelations
  }): Observable<Modelation> {

    return this.freezeModelation$Response(params).pipe(
      map((r: StrictHttpResponse<Modelation>) => r.body as Modelation)
    );
  }

  /**
   * Path part for operation generatePdf
   */
  static readonly GeneratePdfPath = '/api/comparator/generate-pdf/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `generatePdf()` instead.
   *
   * This method doesn't expect any request body.
   */
  generatePdf$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.GeneratePdfPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `generatePdf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  generatePdf(params: {
    id: string;
  }): Observable<void> {

    return this.generatePdf$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getCompleteInformation
   */
  static readonly GetCompleteInformationPath = '/api/comparator/get-complete-information/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompleteInformation()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompleteInformation$Response(params?: {
  }): Observable<StrictHttpResponse<Array<AdvisorStatistics>>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.GetCompleteInformationPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AdvisorStatistics>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCompleteInformation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompleteInformation(params?: {
  }): Observable<Array<AdvisorStatistics>> {

    return this.getCompleteInformation$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AdvisorStatistics>>) => r.body as Array<AdvisorStatistics>)
    );
  }

  /**
   * Path part for operation getDetailedInformation
   */
  static readonly GetDetailedInformationPath = '/api/comparator/get-detailed-information/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDetailedInformation()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDetailedInformation$Response(params: {
    advisor?: string;
    date_from: string;
    date_to: string;

    /**
     * * &#x60;day&#x60; - day
     * * &#x60;week&#x60; - week
     * * &#x60;month&#x60; - month
     */
    granularity?: 'day' | 'week' | 'month';
  }): Observable<StrictHttpResponse<Array<DetailedComparatorAdminViewResult>>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.GetDetailedInformationPath, 'get');
    if (params) {
      rb.query('advisor', params.advisor, {});
      rb.query('date_from', params.date_from, {});
      rb.query('date_to', params.date_to, {});
      rb.query('granularity', params.granularity, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DetailedComparatorAdminViewResult>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getDetailedInformation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDetailedInformation(params: {
    advisor?: string;
    date_from: string;
    date_to: string;

    /**
     * * &#x60;day&#x60; - day
     * * &#x60;week&#x60; - week
     * * &#x60;month&#x60; - month
     */
    granularity?: 'day' | 'week' | 'month';
  }): Observable<Array<DetailedComparatorAdminViewResult>> {

    return this.getDetailedInformation$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DetailedComparatorAdminViewResult>>) => r.body as Array<DetailedComparatorAdminViewResult>)
    );
  }

  /**
   * Path part for operation getPdf
   */
  static readonly GetPdfPath = '/api/comparator/get-pdf/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPdf()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPdf$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.GetPdfPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/pdf'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPdf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPdf(params: {
    id: string;
  }): Observable<Blob> {

    return this.getPdf$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation getAllModelations
   */
  static readonly GetAllModelationsPath = '/api/comparator/list-create-modelation/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllModelations()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllModelations$Response(params?: {
    dateFrom?: string;
    dateTo?: string;
    limit?: number;
    offset?: number;
    text?: string;
  }): Observable<StrictHttpResponse<ModelationsOutput>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.GetAllModelationsPath, 'get');
    if (params) {
      rb.query('dateFrom', params.dateFrom, {});
      rb.query('dateTo', params.dateTo, {});
      rb.query('limit', params.limit, {});
      rb.query('offset', params.offset, {});
      rb.query('text', params.text, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ModelationsOutput>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAllModelations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllModelations(params?: {
    dateFrom?: string;
    dateTo?: string;
    limit?: number;
    offset?: number;
    text?: string;
  }): Observable<ModelationsOutput> {

    return this.getAllModelations$Response(params).pipe(
      map((r: StrictHttpResponse<ModelationsOutput>) => r.body as ModelationsOutput)
    );
  }

  /**
   * Path part for operation createModelationForSpecifiedClient
   */
  static readonly CreateModelationForSpecifiedClientPath = '/api/comparator/list-create-modelation/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createModelationForSpecifiedClient()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createModelationForSpecifiedClient$Response(params: {
    body: ComparatorClient
  }): Observable<StrictHttpResponse<Modelation>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.CreateModelationForSpecifiedClientPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Modelation>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createModelationForSpecifiedClient$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createModelationForSpecifiedClient(params: {
    body: ComparatorClient
  }): Observable<Modelation> {

    return this.createModelationForSpecifiedClient$Response(params).pipe(
      map((r: StrictHttpResponse<Modelation>) => r.body as Modelation)
    );
  }

  /**
   * Path part for operation loadResults
   */
  static readonly LoadResultsPath = '/api/comparator/load-results/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loadResults()` instead.
   *
   * This method doesn't expect any request body.
   */
  loadResults$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<ModelationResultCollection>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.LoadResultsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ModelationResultCollection>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loadResults$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  loadResults(params: {
    id: string;
  }): Observable<ModelationResultCollection> {

    return this.loadResults$Response(params).pipe(
      map((r: StrictHttpResponse<ModelationResultCollection>) => r.body as ModelationResultCollection)
    );
  }

  /**
   * Path part for operation loadModelationWithSpecifiedId
   */
  static readonly LoadModelationWithSpecifiedIdPath = '/api/comparator/load-save-delete-modelation/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loadModelationWithSpecifiedId()` instead.
   *
   * This method doesn't expect any request body.
   */
  loadModelationWithSpecifiedId$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<Modelation>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.LoadModelationWithSpecifiedIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Modelation>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loadModelationWithSpecifiedId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  loadModelationWithSpecifiedId(params: {
    id: string;
  }): Observable<Modelation> {

    return this.loadModelationWithSpecifiedId$Response(params).pipe(
      map((r: StrictHttpResponse<Modelation>) => r.body as Modelation)
    );
  }

  /**
   * Path part for operation saveModelationWithSpecifiedId
   */
  static readonly SaveModelationWithSpecifiedIdPath = '/api/comparator/load-save-delete-modelation/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `saveModelationWithSpecifiedId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveModelationWithSpecifiedId$Response(params: {
    id: string;
    body: Modelation
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.SaveModelationWithSpecifiedIdPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `saveModelationWithSpecifiedId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveModelationWithSpecifiedId(params: {
    id: string;
    body: Modelation
  }): Observable<void> {

    return this.saveModelationWithSpecifiedId$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation deleteModelationWithSpecifiedId
   */
  static readonly DeleteModelationWithSpecifiedIdPath = '/api/comparator/load-save-delete-modelation/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteModelationWithSpecifiedId()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteModelationWithSpecifiedId$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.DeleteModelationWithSpecifiedIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteModelationWithSpecifiedId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteModelationWithSpecifiedId(params: {
    id: string;
  }): Observable<void> {

    return this.deleteModelationWithSpecifiedId$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation loadTheLastNotice
   */
  static readonly LoadTheLastNoticePath = '/api/comparator/load-save-notice/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loadTheLastNotice()` instead.
   *
   * This method doesn't expect any request body.
   */
  loadTheLastNotice$Response(params?: {
  }): Observable<StrictHttpResponse<Notice>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.LoadTheLastNoticePath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Notice>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loadTheLastNotice$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  loadTheLastNotice(params?: {
  }): Observable<Notice> {

    return this.loadTheLastNotice$Response(params).pipe(
      map((r: StrictHttpResponse<Notice>) => r.body as Notice)
    );
  }

  /**
   * Path part for operation saveTheNewNotice
   */
  static readonly SaveTheNewNoticePath = '/api/comparator/load-save-notice/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `saveTheNewNotice()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveTheNewNotice$Response(params?: {
    body?: Notice
  }): Observable<StrictHttpResponse<Notice>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.SaveTheNewNoticePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Notice>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `saveTheNewNotice$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveTheNewNotice(params?: {
    body?: Notice
  }): Observable<Notice> {

    return this.saveTheNewNotice$Response(params).pipe(
      map((r: StrictHttpResponse<Notice>) => r.body as Notice)
    );
  }

  /**
   * Path part for operation getsOrCreatesResultsSettingsForSpecifiedModelation
   */
  static readonly GetsOrCreatesResultsSettingsForSpecifiedModelationPath = '/api/comparator/load-save-report-settings/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getsOrCreatesResultsSettingsForSpecifiedModelation()` instead.
   *
   * This method doesn't expect any request body.
   */
  getsOrCreatesResultsSettingsForSpecifiedModelation$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<ReportFilter>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.GetsOrCreatesResultsSettingsForSpecifiedModelationPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ReportFilter>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getsOrCreatesResultsSettingsForSpecifiedModelation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getsOrCreatesResultsSettingsForSpecifiedModelation(params: {
    id: string;
  }): Observable<ReportFilter> {

    return this.getsOrCreatesResultsSettingsForSpecifiedModelation$Response(params).pipe(
      map((r: StrictHttpResponse<ReportFilter>) => r.body as ReportFilter)
    );
  }

  /**
   * Path part for operation updatesResultsSettingsForSpecifiedModelation
   */
  static readonly UpdatesResultsSettingsForSpecifiedModelationPath = '/api/comparator/load-save-report-settings/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatesResultsSettingsForSpecifiedModelation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatesResultsSettingsForSpecifiedModelation$Response(params: {
    id: string;
    body: ReportFilter
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.UpdatesResultsSettingsForSpecifiedModelationPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updatesResultsSettingsForSpecifiedModelation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatesResultsSettingsForSpecifiedModelation(params: {
    id: string;
    body: ReportFilter
  }): Observable<void> {

    return this.updatesResultsSettingsForSpecifiedModelation$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation modelationConfig
   */
  static readonly ModelationConfigPath = '/api/comparator/modelation-config/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `modelationConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  modelationConfig$Response(params?: {
  }): Observable<StrictHttpResponse<ModelationConfig>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.ModelationConfigPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ModelationConfig>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `modelationConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  modelationConfig(params?: {
  }): Observable<ModelationConfig> {

    return this.modelationConfig$Response(params).pipe(
      map((r: StrictHttpResponse<ModelationConfig>) => r.body as ModelationConfig)
    );
  }

  /**
   * Path part for operation paymentCalendar
   */
  static readonly PaymentCalendarPath = '/api/comparator/payment-calendar/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentCalendar()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paymentCalendar$Response(params: {
    body: PaymentCalendarInput
  }): Observable<StrictHttpResponse<Array<Payment>>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.PaymentCalendarPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<Payment>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `paymentCalendar$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paymentCalendar(params: {
    body: PaymentCalendarInput
  }): Observable<Array<Payment>> {

    return this.paymentCalendar$Response(params).pipe(
      map((r: StrictHttpResponse<Array<Payment>>) => r.body as Array<Payment>)
    );
  }

  /**
   * Path part for operation readInfo
   */
  static readonly ReadInfoPath = '/api/comparator/read-info/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `readInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  readInfo$Response(params?: {
  }): Observable<StrictHttpResponse<Info>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.ReadInfoPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Info>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `readInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  readInfo(params?: {
  }): Observable<Info> {

    return this.readInfo$Response(params).pipe(
      map((r: StrictHttpResponse<Info>) => r.body as Info)
    );
  }

  /**
   * Path part for operation readNotice
   */
  static readonly ReadNoticePath = '/api/comparator/read-notice/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `readNotice()` instead.
   *
   * This method doesn't expect any request body.
   */
  readNotice$Response(params?: {
  }): Observable<StrictHttpResponse<Notice>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.ReadNoticePath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Notice>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `readNotice$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  readNotice(params?: {
  }): Observable<Notice> {

    return this.readNotice$Response(params).pipe(
      map((r: StrictHttpResponse<Notice>) => r.body as Notice)
    );
  }

  /**
   * Path part for operation rejectNotice
   */
  static readonly RejectNoticePath = '/api/comparator/reject-notice/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rejectNotice()` instead.
   *
   * This method doesn't expect any request body.
   */
  rejectNotice$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.RejectNoticePath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rejectNotice$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rejectNotice(params?: {
  }): Observable<void> {

    return this.rejectNotice$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation resetGraphFileStatus
   */
  static readonly ResetGraphFileStatusPath = '/api/comparator/reset-graph-file-status/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resetGraphFileStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  resetGraphFileStatus$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.ResetGraphFileStatusPath, 'delete');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resetGraphFileStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resetGraphFileStatus(params?: {
  }): Observable<void> {

    return this.resetGraphFileStatus$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation sendMail
   */
  static readonly SendMailPath = '/api/comparator/send-mail/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendMail()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendMail$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.SendMailPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `sendMail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendMail(params: {
    id: string;
  }): Observable<void> {

    return this.sendMail$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation uploadExcelFile
   */
  static readonly UploadExcelFilePath = '/api/comparator/upload-excel-file/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadExcelFile()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadExcelFile$Response(params: {
    body: UploadFiles
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ComparatorService.UploadExcelFilePath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `uploadExcelFile$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadExcelFile(params: {
    body: UploadFiles
  }): Observable<void> {

    return this.uploadExcelFile$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
